import * as React from 'react';
import Avatar from '@mui/material/Avatar';

export function renderAvatar(params) {
  if (params.value == null) {
    return '';
  }

  return (
    <Avatar
      sx={{
        backgroundColor: params.value.color,
        width: '24px',
        height: '24px',
        fontSize: '0.85rem',
      }}
    >
      {params.value.name.toUpperCase().substring(0, 1)}
    </Avatar>
  );
}

export const columns = [
  { field: 'id', headerName: 'ID', flex: 1, minWidth: 80, editable: false },
  { field: 'name', headerName: 'Channel Name', flex: 1.5, minWidth: 200, editable: true },
  { field: 'index', headerName: 'Index Level', flex: 1, minWidth: 150, editable: true },
  { field: 'url', headerName: 'URL', flex: 1.5, minWidth: 200, editable: true },
  // {
  //   field: 'status',
  //   headerName: 'Status',
  //   flex: 0.5,
  //   minWidth: 80,
  //   renderCell: (params) => renderStatus(params.value),
  // },
  // {
  //   field: 'users',
  //   headerName: 'Users',
  //   headerAlign: 'right',
  //   align: 'right',
  //   flex: 1,
  //   minWidth: 80,
  // },
  // {
  //   field: 'eventCount',
  //   headerName: 'Event Count',
  //   headerAlign: 'right',
  //   align: 'right',
  //   flex: 1,
  //   minWidth: 100,
  // },
  // {
  //   field: 'viewsPerUser',
  //   headerName: 'Views per User',
  //   headerAlign: 'right',
  //   align: 'right',
  //   flex: 1,
  //   minWidth: 120,
  // },
  // {
  //   field: 'averageTime',
  //   headerName: 'Average Time',
  //   headerAlign: 'right',
  //   align: 'right',
  //   flex: 1,
  //   minWidth: 100,
  // },
];
